import React from "react";
//#region types
import { MonthBannerProps } from "models/propTypes/timeReportingPropTypes";
import { TimeReportingEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DateConstants } from "utils/constants";
//#endregion
//#region components
import TimeReportingBanner from "../banner";
import { Grid } from "@mui/material";
//#endregion
import LocalizationHelperInstance from "utils/helpers/localizationHelper";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const BannerContainer: React.FC<MonthBannerProps> = (props) => {
  const { monthData, monthWeeks, monthStatus } = props;
  const [billableHours, setBillableHours] = React.useState<number>(0);
  const [internalHours, setInternalHours] = React.useState<number>(0);
  const [absenceHours, setAbsenceHours] = React.useState<number>(0);

  React.useEffect(() => {
    let deviationHours = 0;
    let projectHours = 0;
    let interHours = 0;
    monthWeeks?.forEach((week) => {
      monthData?.forEach((row) => {
        const hours = week.displayText ? Number((row as any)[week.displayText]) : 0;
        if (hours > 0) {
          if (row.type === TimeReportingEnums.TimeReportType.deviation) {
            deviationHours += hours;
          } else if (row.type === TimeReportingEnums.TimeReportType.project) {
            if (row.isInternal) {
              interHours += hours;
            } else {
              projectHours += hours;
            }
          }
        }
      });
    });
    setBillableHours(projectHours);
    setAbsenceHours(deviationHours);
    setInternalHours(interHours);
  }, [monthData]);

  const monthLong =
    props.dateRange?.start &&
    LocalizationHelperInstance.getFormattedDate(props.dateRange?.start, DateConstants.MonthLongConfig).toLowerCase();

  return (
    <TimeReportingBanner
      billableHours={billableHours}
      internalHours={internalHours}
      absenceHours={absenceHours}
      compHours={props.compHours ?? 0}
      title={
        <Grid container spacing={2} alignItems="center" className={cssExports.bannerOuterContainer}>
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.TimeMonth, "", {
              monthLong: monthLong ?? "",
            })}
          </Grid>
          <Grid item>
            <div className={clsx(cssExports.statusLabel, cssExports.right)}>
              {LocalizationHelperInstance.getFormattedMessage(`TimeReporting.TimeReportStatus_${monthStatus}`)}
            </div>
          </Grid>
        </Grid>
      }
    ></TimeReportingBanner>
  );
};

export default BannerContainer;
